module.exports = __webpack_public_path__ + "assets/handlebars.95ddbc9b.svg";